export default __webpack_public_path__ + "static/m-500-7c800d89636ed2517c0ea324b417287d.png";